import { c as _c } from "react/compiler-runtime";
import { useMutation } from "@tanstack/react-query";
import { useApiFetcher } from "../ApiProvider";
interface SessionFeedbackInput {
  sessionId: string;
  feedbackScore: number;
}
export function useSessionFeedback() {
  const $ = _c(2);
  const apiFetcher = useApiFetcher();
  let t0;
  if ($[0] !== apiFetcher) {
    t0 = {
      mutationFn: t1 => {
        const {
          sessionId,
          feedbackScore
        } = t1;
        return apiFetcher(`/api/v1/sessions/${sessionId}/feedback`, {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            feedbackScore
          })
        });
      }
    };
    $[0] = apiFetcher;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
}